const PRODUCTION_HOSTNAMES = ['www.sorpetaler.de', 'sorpetaler.de'];

const STAGING_LOGIN_PATHS = ['/login/staging', '/en/login/staging'];

export function isStagingLoginPath(pathname?: string): boolean {
  const path =
    pathname ??
    (typeof window !== 'undefined' ? window.location.pathname : '');
  const normalized = path.replace(/\/$/, '') || '/';
  return STAGING_LOGIN_PATHS.includes(normalized);
}

export function isProductionSite(
  hostname?: string,
  pathname?: string
): boolean {
  const envOverride = process.env.GATSBY_METRICA_ENV;
  if (envOverride === 'production') return true;
  if (envOverride === 'staging') return false;

  if (isStagingLoginPath(pathname)) return false;

  if (typeof window === 'undefined') {
    return true;
  }

  const host = (hostname ?? window.location.hostname).toLowerCase();
  return PRODUCTION_HOSTNAMES.includes(host);
}
